import { FormatterEx } from 'slickgrid';
import { CommandColumn, CommandColumnOptions } from '../plugins';

const DEFAULTS = {};

export interface CommandFormatterOptions<T> extends CommandColumnOptions<T> {}

export function command<T>(opts: CommandFormatterOptions<T>): FormatterEx<T> {
  const vals = { ...DEFAULTS, ...opts };

  const result = new CommandColumn(opts);

  const commandFormatter: FormatterEx<T> = (
    row,
    cell,
    value,
    columnDef,
    data,
  ) => {
    return value;
  };

  commandFormatter.exportRawData = true;

  return commandFormatter;
}
